import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Container,
  Stack,
  Typography,
} from '@mui/material';
import { createFoundationDraft } from '../../../endpoints/foundation';
import PageHeader from '../../../Components/PageHeader';

const ACADEMIC_YEAR = '2025-2026';

/** Share one in-flight create across Strict Mode remounts / effect re-runs. */
let pendingDraftId: Promise<string> | null = null;

/**
 * Creates an empty Hub draft immediately, then replaces the URL with the draft
 * detail editor (tabs + autosave).
 */
export default function FoundationApplicantCreate() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        if (!pendingDraftId) {
          pendingDraftId = createFoundationDraft({
            academic_year: ACADEMIC_YEAR,
          }).then((draft) => draft.id);
        }
        const id = await pendingDraftId;
        if (!cancelled) {
          pendingDraftId = null;
          navigate(`/foundation/applicants/${id}`, { replace: true });
        }
      } catch (e: any) {
        pendingDraftId = null;
        if (!cancelled) {
          setError(
            e?.message || 'Failed to create Individual Case History draft'
          );
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <Container maxWidth="md" sx={{ py: 2 }}>
      <PageHeader
        title="Individual Case History Form"
        leftDom={undefined}
        rightDom={undefined}
        subtitle="ICH"
      />
      {error ? (
        <>
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
          <Button
            onClick={() => {
              setError(null);
              pendingDraftId = null;
              navigate(0);
            }}
          >
            Try again
          </Button>
          <Button
            onClick={() => navigate('/foundation/applicants')}
            sx={{ ml: 1 }}
          >
            Back to applicants
          </Button>
        </>
      ) : (
        <Stack direction="row" spacing={2} alignItems="center" sx={{ mt: 2 }}>
          <CircularProgress size={22} />
          <Box>
            <Typography>Creating your draft…</Typography>
            <Typography variant="body2" color="text.secondary">
              You will land on the Student, Scholarship, and Recommendation tabs
              in a moment.
            </Typography>
          </Box>
        </Stack>
      )}
    </Container>
  );
}
